import { render, staticRenderFns } from "./precisionFarming.vue?vue&type=template&id=4a6674f6&"
import script from "./precisionFarming.vue?vue&type=script&lang=js&"
export * from "./precisionFarming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports